module.exports = __webpack_public_path__ + "static/callsheets_mobile-e87cc1d9a75a5fc1998f26ee8e02f958.png";